<template>
  <div class="privacy-policy-app">
		<section>
			<h2>隐私政策</h2>
			<p>本隐私指引适用于院校情报产品自身的功能及服务（包括即时讯息、各类排名、大学360、学科监测、排名报告等，不适用于其他通过院校情报网站或客户端提供的产品或服务，或任何其他第三方提供的产品或服务（以下统称“第三方服务”），你在选择使用第三方服务前应充分了解第三方服务的产品功能及隐私保护政策。</p>
		</section>
		<section>
			<p>本隐私指引将帮助你了解以下内容：</p>
      <ul>
        <li><span>1.</span> 我们收集哪些类型的信息 </li>
        <li><span>2.</span> 我们如何存储这些信息  </li>
        <li><span>3.</span> 我们如何保护这些信息</li>
        <li><span>4.</span> 我们如何使用这些信息</li>
        <li><span>5.</span> 信息的对外提供、公开和转移</li>
        <li><span>6.</span> 你如何查阅和管理个人信息</li>
        <li><span>7.</span> 未成年人保护</li>
        <li><span>8.</span> Mob隐私协议</li>
        <li><span>9.</span> 本隐私指引的变更</li>
        <li><span>10.</span> 联系我们</li>
      </ul>
      <p>相关定义：</p>
			<p><b>院校情报：</b>院校情报是由上海高绩数据科技有限公司提供的一款全方位监测大学排名和竞争力的专业化移动端工具。院校情报产品及服务，包括院校情报iOS、Android客户端等。</p>
      <p><b>院校情报运营主体：</b>指注册、登录、使用院校情报产品及服务并获得管理权限的个人或组织，包括但不限于法人（如公司、政府机构、事业单位等）、非法人组织（如合伙企业等）、个体工商户等（又称“企业用户”“你所加入的企业用户”或“你的企业”）；企业用户可以通过院校情报创建其工作平台（指由企业用户创建并管理的，可以多人加入共同使用院校情报服务的虚拟工作空间），邀请并授权个人用户加入其工作平台成为其最终用户。</p>
      <p><b>企业用户管理员：</b>指经企业用户指定，拥有企业用户管理后台系统操作权限的个人；企业用户管理员只能为一人。</p>
      <p><b>个人用户/最终用户：</b>指被企业用户邀请加入企业工作平台，注册使用院校情报的个人用户，以下称“你”或“最终用户”。</p>
      <p><b>个人信息：</b>指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</p>
      <p><b>敏感个人信息：</b>是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>
    </section>
		<section>
			<h3>1、	我们收集哪些类型的信息</h3>
			<ul>
        <li>
          <b>1.1 为了向你和企业用户提供服务、保障服务的正常运行以及保障你的帐号安全，我们将需要向你索取相关的权限。</b>
        </li>
        <li>
          <p>1.2 为了向你和企业用户提供服务、保障服务的正常运行、改进和优化我们的服务以及保障帐号安全，院校情报会按照如下方式收集你在注册、使用服务时主动提供、授权提供或因为使用服务而产生的信息：</p>
          <p>1.2.1 帐号注册信息：当你首次登录院校情报，你需要提供你的手机号，上述信息为你使用院校情报所必需，若你不提供这类信息，你将无法正常使用我们的服务。</p>
          <p>1.2.2 当你使用院校情报服务时，为向你及企业用户提供院校情报产品及服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障你的帐号安全或基于遵守法律法规规定的需求，我们会收集你下述信息：</p>
          <ul>
            <li><span>（1）</span>设备信息：根据你在安装及使用院校情报服务过程中的设备型号及授予的权限，我们会收集使用院校情报服务的设备相关信息，包括ICCID、设备型号、操作系统、Mac地址、唯一设备标识符（指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备，如手机的IMEI号、AndroidID、IMSI等）、院校情报软件版本号等。</li>
            <li><span>（2）</span>日志信息：当你使用院校情报服务时，我们会收集你对服务使用的日志信息，包括接入网络的方式、类型和状态、网络质量数据、操作日志、服务日志信息（如你在院校情报查看的网址信息、服务故障信息等）等。</li>
            <li><span>（3）</span>你通过我们的客服或参加我们举办的活动时所提交的信息。例如，你参与我们线上活动时填写的调查问卷中可能包含你的姓名、<b>电话、家庭地址</b>等信息。</li>
          </ul>
        </li>
        <li>
          <p>1.3  企业用户委托我们提供院校信息及服务等，企业用户委托我们处理企业用户和该企业用户的最终用户使用院校情报过程中提交或产生的信息和数据，包括企业用户提交或要求最终用户提供的信息、企业用户分配给最终用户的信息，以及为完成工作需求、满足企业日常管理需求而由最终用户提交给企业用户的信息（以下简称“受托处理的个人信息”）。<b>企业用户是此类个人信息的处理者。我们接受企业用户的委托，根据企业用户的指示（包括企业用户以及企业用户管理员通过管理后台进行的操作等），以及我们与企业用户间的协议或基于提供办公管理及通讯服务等目的处理此类个人信息。</b>受托处理的个人信息包括：</p>
          <p>1.3.1 你的姓名、性别、<b>手机号</b>以及<b>院系信息</b>等企业用户提交或要求你提供的个人信息。</p>
          <p>1.3.2 当企业用户进行新账号注册时，企业用户需要提供创建人信息，我们接受企业用户的委托收集创建人的个人信息以帮助企业用户实现注册。</p>
          <p>1.3.3 为了让你更安全使用登录服务，你可选择开通指纹解锁功能（若你的设备可适用）。<b>你需在你的设备上录入你的指纹信息，在你进行指纹登录时，你需在你的设备上完成指纹验证。我们仅接收验证结果，并不收集你的指纹信息。上述信息属于敏感个人信息，拒绝提供该信息仅会使你无法使用指纹解锁功能，但不影响你正常使用院校情报的其他功能。</b></p>
          <p>1.3.4 其他由企业用户或终端用户提交的或产生的数据，如组织架构、审批流程等。</p>
          <p>1.3.5 企业用户在上传，管理，收集，处理，存储，对外提供其最终用户个人信息和委托我们处理最终用户个人信息之前，<b>应确保已经按照相关法律法规事先获得最终用户的明确同意，且已充分告知最终用户相关数据收集的目的、范围、使用方式、保护措施和委托我们进行处理的情况等。</b></p>
        </li>
        <li>
          <b>1.4 请你理解，我们向你提供的功能和服务是不断更新和发展的，如果某一功能或服务（例如小范围测试、实验性功能等）未在前述说明中告知收集你的信息的处理规则，我们会通过页面提示、交互流程、网站公告等方式另行向你告知信息收集的范围、目的及方式，并征得你的同意。</b>
        </li>
			</ul>
		</section>
		<section>
      <h3>2、	我们如何存储这些信息</h3>
      <ul>
        <li>
          <h5>2.1 信息存储的地点</h5>
          <p>我们会按照法律法规规定，将在中国境内收集和产生的个人信息存储于中国境内。如果你的个人信息存储地点从中国境内转移到境外的，我们将严格依照法律法规的规定执行。</p>
        </li>
        <li>
          <h5>2.2 信息存储的期限</h5>
          <p>当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知你，在合理的期限内删除你的个人信息或进行匿名化处理，并立即停止收集个人信息的活动，以及关闭第三方应用服务接口，避免第三方服务收集及继续使用个人信息。</p>
        </li>
      </ul>
    </section>

		<section>
      <h3>3、我们如何保护这些信息</h3>
			<p>3.1 我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。</p>
      <p>3.2 我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，SSL /TLS）、去标识化或匿名化处理等手段来保护你的个人信息。</p>
      <p>3.3 我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成部分信息加密的工作；为了预防病毒、木马程序或其他恶意程序、网站，我们可能会检测你设备安装的应用、正在运行的进程或设备内存中寄存的信息是否存在安全隐患；为了预防诈骗、盗号、仿冒他人等不法行为和进行安全检查我们可能会分析利用唯一设备标识符、登陆IP地址、操作日志、地理位置信息等数据，以便于采取安全措施或对用户进行安全提醒等。</p>
      <p>3.4 若发生个人信息泄露等安全事件，我们会依法启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知你安全事件的情况、事件可能对你的影响以及我们将采取的补救措施。我们还将按照法律法规和监管部门要求，上报个人信息安全事件的处置情况。</p>
      <p>3.5 目前，院校情报在信息安全与网络安全方面已达到ISO/IEC 20000、ISO/IEC 27001、ISO/IEC 27018、网络安全等级保护（三级）系等国际及国内权威认证标准的要求，并已获得了相应的认证。</p>
      <p>我们会尽力保护你的个人信息。我们也请你理解，任何安全措施都无法做到无懈可击。</p>
		</section>
		<section>
      <h3>4、我们如何使用这些信息</h3>
      <p>我们严格遵守法律法规的规定及与用户的约定，将收集的信息按照本隐私指引的规定用于以下用途。</p>
      <p>4.1 我们在你使用院校情报服务过程中收集的个人信息或受企业用户委托收集的个人信息是为了向院校情报用户（包括企业用户和最终用户）打造和提供更好的服务。我们会将收集的信息用于以下用途：</p>
      <p>4.1.1 提供、维护及开发院校情报服务：我们会利用收集的信息来提供和优化改进院校情报服务，例如，跟踪服务中断情况或排查院校情报用户向我们报告的问题；根据院校情报日志、服务使用信息等为你或你所在企业用户提供各类数据统计分析功能及服务。</p>
      <p>4.1.2 安全保障：为保障你以及所有院校情报用户的安全，我们会利用相关信息协助提升院校情报服务的安全性和可靠性，包括检测、防范和应对可能危害院校情报、我们的用户或公众的欺诈行为、滥用行为、非法行为、安全风险和技术问题等。</p>
      <p>4.1.3 与你沟通：我们会利用收集的信息（例如你提供的电子邮件地址、企业用户的管理者联系邮箱、电话等）直接与你沟通。例如，如果我们检测到可疑活动（如尝试从不同于平常的位置登录你的院校情报），则可能会向你发送通知，我们可能会让你了解院校情报即将发生的变化或即将进行的改进。或者，我们会对你进行服务回访。</p>
      <p>4.1.4 为了遵从相关法律法规、政府指令的相关要求。</p>
      <p>目前，我们不会将你的个人信息用于个性化广告用途。如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围或超出企业用户委托的范围，我们将在使用你的个人信息前，通过页面提示、交互流程、网站公告等方式另行向你告知并征得你的明示同意。</p>
      <p>4.2 对于受托处理的个人信息，我们将根据企业用户的决定以及我们与企业用户的相关协议，或其在后台的操作依法予以处理。例如，企业用户有权决定在院校情报内展示哪些以及如何展示最终用户的相关信息。</p>
      <p><b>4.3 根据相关法律法规，在以下情况下我们可能会收集、使用你的个人信息而无需征求你的授权同意：</b></p>
      <p><b>4.3.1 为订立、履行个人作为一方当事人的合同所必需；</b></p>
      <p><b>4.3.2 为履行法定职责或者法定义务所必需；</b></p>
      <p><b>4.3.3 为应对突发公共卫生事件，或者紧急情况下为保护你的生命健康和财产安全所必需；</b></p>
      <p><b>4.3.4 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理你的个人信息；</b></p>
      <p><b>4.3.5 在合理的范围内处理你自行公开或者其他已经合法公开的个人信息；</b></p>
      <p><b>4.3.6 法律、行政法规规定的其他情形。</b></p>
    </section>
		<section>
			<h3>5、信息的对外提供、公开和转移</h3>
			<p>我们不会将你的个人信息提供给第三方，但以下情况除外：</p>
      <p>5.1 获取你的明确同意：经你事先单独同意，我们可能向第三方提供你的个人信息。</p>
      <p>5.2 为实现外部处理的目的，我们可能会向关联公司或其他第三方合作伙伴提供你的个人信息，让他们按照我们的说明、隐私政策以及其他相关的保密和安全措施来为我们处理上述信息，并用于向你提供我们的服务，实现“我们如何使用信息”部分所述目的。我们会采取严格的技术手段保障你的信息安全。</p>
      <p>5.3 我们不会对外公开披露所收集的个人信息。如必须公开披露时，我们会向你告知此次公开披露的目的、披露信息的类型及可能涉及的敏感个人信息，并遵从相关法律法规的要求进行披露。需要特别说明的是，关于最终用户相关信息如何在其加入的企业用户工作平台中对外披露或共享，由企业用户决定并管理，如果你对此有任何疑问或意见，你理解并同意联系你所在企业用户或企业用户管理员处理。</p>
      <p>5.4 随着我们业务的持续发展，我们有可能因合并、收购、资产转让等需要转移个人信息的，我们将告知你相关情形（包括接收方的名称或者姓名和联系方式），按照法律法规及不低于本隐私指引所要求的标准继续保护或要求新的个人信息接收方继续保护你的个人信息。</p>
      <p>5.5 侵权投诉处置：在你被他人投诉存在侵犯知识产权或其他合法权利的行为时，我们需要向投诉人披露你的必要资料，以便进行投诉处理。</p>
      <p>5.6 我们可能基于法律要求或相关部门的执法要求披露你的个人信息。</p>
      <p><b>5.7 根据相关法律法规及国家标准，以下情形中，我们对外提供、公开披露用户的个人信息无需事先征得你的授权同意：</b></p>
      <p><b>5.7.1 与我们履行法律法规规定的义务相关的；</b></p>
      <p><b>5.7.2 与国家安全、国防安全直接相关的；</b></p>
      <p><b>5.7.3 与公共安全、公共卫生、重大公共利益直接相关的；</b></p>
      <p><b>5.7.4 与刑事侦查、起诉、审判和判决执行等直接相关的；</b></p>
      <p><b>5.7.5 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</b></p>
      <p><b>5.7.6 个人信息主体自行向社会公众公开的个人信息；</b></p>
      <p><b>5.7.7 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</b></p>
		</section>
		<section>
      <h3>6、你如何查阅及管理个人信息</h3>
			<p>在你使用院校情报期间，为了你可以更加便捷地查阅、复制、更正、补充、删除你的个人信息及要求我们解释个人信息处理规则，同时保障你撤回同意、退出企业（注销帐号）的权利，我们在产品设计中为你提供了相应的操作设置，你可以参考下面的指引进行操作。</p>
      <p><b>请注意，不同操作系统、院校情报软件的不同版本之间，操作设置可能存在差异；</b>此外，为了优化你的使用体验，我们也可能对操作设置进行调整。故如下指引仅供参考，若你对行使相关权利的方式及途径仍有任何疑问的，你可以通过本隐私指引第10条披露的方式与我们联系。</p>
      <p>6.1 查阅信息</p>
      <p>查阅头像、姓名、学校、部门、职务、<b>手机号</b>、等基本信息：</p>
      <ul>
        <li><span>（1）</span>进入院校情报后，在我的界面点击左上角的头像区域；</li>
        <li><span>（2）</span>点击头像栏；</li>
        <li><span>（3）</span>查阅个人信息。</li>
      </ul>
      <p>注：当你退出所在企业，我们将在合理期间内删除或匿名化处理你在该企业的相关个人信息。当你退出所有企业，即视为注销帐号，我们将停止为你提供服务，并在合理期限内删除或匿名化处理你的个人信息。</p>
      <p>6.2 你的近亲属的查询、复制、更正、删除权利</p>
      <p>6.2.1 根据《个人信息保护法》的规定，若自然人死亡的，其近亲属为了自身合法、正当利益可以对死者的相关个人信息行使查询、复制、更正、删除权利。若你的近亲属希望查询、复制、更正、删除你的个人信息，包括头像，姓名，实名，性别，所属企业，微信，<b>手机号</b>，登录记录，你的近亲属可以通过第10节中的联系方式与我们联系，在核实你的身份后，为进一步需要核实的事实及情形的需要，我们有权要求你的近亲属进一步提供证明或说明材料，我们会在核实后向你的近亲属提供相应服务。但法律法规及本隐私指引另有约定的除外。</p>
      <p>6.2.2 若你的近亲属希望查询、复制、更正、删除你所加入的企业用户作为数据处理者收集的信息，请联系你的企业和你的企业管理员。上述信息包括且并不限于，发票抬头、工作签名、座机号码、电子邮箱地址、职位、职级、职务、隶属部门、传真号码、办公座位，审批记录、文件盘、文档信息、公费电话使用情况、企业邮箱帐号、组织架构、审批流程与企业用户相关或企业用户分配给你的信息，你在使用打卡功能时的地理位置信息及打卡记录等。<b>因为此类信息由你的企业所处理，你的企业和你的企业管理员对是否向你的近亲属提供查询、复制、更正、删除此类信息具有决定权。</b></p>
		</section>
		<section>
      <h3>7、未成年人保护</h3>
			<p>我们非常重视对未成年人个人信息的保护，根据相关法律法规的规定，若你是14周岁以下的未成年人，在你使用院校情报的产品/服务前，除仔细阅读并了解本隐私指引外，你还应取得你的家长或法定监护人对本隐私指引与的书面同意。若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过第10节中的联系方式与我们联系。</p>
		</section>
		<section>
      <h3>8、Mob隐私协议</h3>
      <p>我们使用了第三方（上海游昆信息技术有限公司，以下称“MobTech”）MobTech MobPushSDK服务为您提供 消息推送功能。为了顺利实现该功能，您需要授权MobTechSDK提供对应的服务;在您授权后，MobTech将收集您相关的个人信息。关于MobTech所收集的信息种类、用途、个人信息保护的规则及退出机制等，详见MobTech官网（<a href="http://www.mob.com">www.mob.com</a>）上的隐私政策 （<a href="http://www.mob.com/about/policy">www.mob.com/about/policy</a>）条款。</p>
			<ul>
				<li><span>（1）</span>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等。</li>
				<li><span>（2）</span>个人信息共享、转让或公开披露的主要对象发生变化。</li>
				<li><span>（3）</span>您参与个人信息处理方面的权利及其行使方式发生重大变化。</li>
				<li><span>（4）</span>其他可能对您的个人信息权益产生重大影响的变化时。</li>
			</ul>
		</section>
    <section>
      <h3>9、本隐私指引的变更</h3>
      <p> 我们可能会适时对本隐私指引进行修订。当指引的条款发生变更时，我们会通过官网公告、推送通知形式向你展示变更后的指引。</p>
      <p> 当本隐私指引的条款发生重大变更时，我们将会通过官网公告、推送通知或者更为显著的弹窗方式向你告知。</p>
      <p> 本条所指的重大变更包括但不限于：</p>
      <ul>
        <li><span>（1）</span>我们的服务模式发生重大变化，如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</li>
        <li><span>（2）</span>我们在所有权结构、组织架构等方面发生重大变化，如业务调整、破产并购等引起的所有者变更等；</li>
        <li><span>（3）</span>个人信息对外提供、转移或公开披露的主要对象发生变化；</li>
        <li><span>（4）</span>你参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
        <li><span>（5）</span>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</li>
        <li><span>（6）</span>个人信息安全影响评估报告表明存在高风险时。</li>
      </ul>
    </section>
    <section>
			<h3>10、联系我们</h3>
      <p>我们设立了专门的个人信息保护团队和个人信息保护负责人，如果你对本隐私指引或个人信息保护相关事宜有任何疑问或投诉、建议时，你可以通过以下任一方式与我们联系：</p>
      <ul>
        <li><span>（1）</span>通过021-64315006与我们联系；</li>
        <li><span>（2）</span>将你的问题发送至support@gaojidata.com；</li>
      </ul>
			<p>我们将尽快审核所涉问题，并在接到投诉之日起十五日内予以回复。</p>
		</section>
  </div>
</template>

<script>
import { getUserInfo, updateUserInfo } from "@/api/profile";
import {
  sendSmsAuthCode,
  addMobileCheck,
  saveMobile,
  removeMobile,
} from "@/api/login";
export default {
  name: "privacy_policy-app",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scope>
.privacy-policy-app {
  text-align: left;
  font-size: 14px;
  color: #343438;
	word-break: break-all;
	section{
    font-size: 14px;
    line-height: 22px;
    color: #343438;
		margin-bottom: 54px;
		h2 {
			height: 32px;
			line-height: 32px;
			margin: 9px 0;
			font-size: 20px;
			color: #434345;
			margin-bottom: 8px;
		}
		h3{
			font-size: 16px;
			height: 16px;
			line-height: 16px;
			margin-bottom: 18px;
		}
		h5{
			font-size: 14px;
			font-weight: 600;
			margin-bottom: 14px;
		}
		p{
			margin-bottom: 14px;
		}
		div{
			margin-bottom: 14px;
		}
    ul{
      margin-bottom: 14px;
    }
		li{
			span{
				display: inline-block;
				margin-right: 0px;
			}
		}
	}
}
</style>
